import $ from 'jquery';
import { get as t } from '../../../home24/core/translation';
import { parseFilename } from '../../../home24-shared/core/Utils';
import * as config from '../../../home24/core/config';

export default function UploadManager() {
    'use strict';

    this.$form = null;
    this.$input = null;
    this.onSuccess = null;

    /**
     * @type {function}
     */
    this.onFailure = null;
    this.uid = null;

    this.aErrors = [];

    this.$scope = $('body');

    /**
     * @return {string}
     */
    this.getUid = function () {
        return this.uid;
    };

    this.setForm = function ($element) {
        this.$form = $element;

        return this;
    };

    this.setInput = function ($element) {
        this.$input = $element;

        return this;
    };

    this.getParsedFilename = function () {
        return parseFilename(this.$input.val());
    };

    // extracted mostly for stubbing purposes
    //
    // <input type="file"/> value attribute cannot
    // be set / stubbed during testing
    this.getFilename = function () {
        return this.$input.val();
    };

    this.validate = function () {
        var validFileExtensions = ['.jpg', '.jpeg', '.gif', '.png'];
        const filename = this.getFilename();
        var valid = false;
        var currentExtension;

        this.aErrors = [];

        if (filename.length === 0) {
            this.aErrors.push({ code: 1, message: t('fileUpload.noFile.message') });

            return;
        }

        if (filename.length < 5) {
            this.aErrors.push({ code: 2, message: t('fileUpload.nameTooShort.message') });

            return;
        }

        // Check file extension
        for (var j = 0; j < validFileExtensions.length; j++) {
            currentExtension = validFileExtensions[j];
            if (filename.substr(filename.length - currentExtension.length, currentExtension.length).toLowerCase() === currentExtension.toLowerCase()) {
                valid = true;
                break;
            }
        }

        if (!valid) {
            this.aErrors.push({ code: 3, message: t('fileUpload.unknownExtension.message') });
        }
    };

    this.isValid = function () {
        return this.aErrors.length === 0;
    };

    this.getErrors = function () {
        return this.aErrors;
    };

    /**
     * Method generates pseudo UUID used for APC Upload Progress
     * @param {=string} prefix
     * @return {string}
     */
    this.createUUID = function (prefix) {
        var s = [];
        var hexDigits = '0123456789abcdef';
        var i;
        var uuid;

        for (i = 0; i < 16; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4';
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);

        uuid = s.join('');

        if (prefix) {
            uuid = prefix + '_' + uuid;
        }

        return uuid;
    };

    this.getIframeId = function (uid) {
        return 'postiframe_' + uid;
    };

    this.setOnSuccess = function (handler) {
        this.onSuccess = handler;

        return this;
    };

    this.setOnFailure = function (handler) {
        this.onFailure = handler;

        return this;
    };

    this.execute = function () {

        this.uid = this.createUUID();

        var frameId = this.getIframeId(this.uid);

        /*
        Inject iframe for async operations
         */
        this.$scope.append('<iframe name="' + frameId + '" id="' + frameId + '" class="fileUpload" />');

        this.$form.attr('target', frameId).submit();

        this.$scope.find('#' + frameId).load($.proxy(this.onRequestFinished, this));
    };

    /**
     * Method removes hidden iframe from DOM
     * @return void
     */
    this.removeUploadIframe = function () {
        this.$scope.find('#' + this.getIframeId(this.uid)).remove();
    };

    /**
     * Method if fired when iframe post request is completed
     * @return void
     */
    this.onRequestFinished = function () {
        var replyText = $(frames[this.getIframeId(this.uid)].document.documentElement).text();
        var replyJSON = {};

        try {
            replyJSON = $.parseJSON(replyText);
        } catch (e) {
            // Parsing reply JSON failed, there was an error
            this.onFailure(this.uid, {});

            return;
        }

        // Empty response returned, parseJSON returned null or undefined or 'success' property is not true
        if (!replyJSON) {
            this.onFailure(this.uid, {});
        } else if (replyJSON.success !== true && replyJSON.success !== 'true') {
            this.onFailure(this.uid, replyJSON);
        } else {
            // On any other situation upload was successful
            this.onSuccess(this.uid, replyJSON);
        }

        this.removeUploadIframe();
    };

    this.remove = function (uid) {
        $.post(config.getBaseUrl() + config.get('fttc2.upload.delete.url'), { uid: uid }, function () {});
    };

}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/pages/fttc2/UploadManager.js
 **/